import { booleanAttribute, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-submit',
  imports: [NgClass],
  template: `
    <button
      [ngClass]="btnClass"
      class="btn btn-primary"
      type="submit"
      [id]="btnID"
      [disabled]="busy || disabled">
      @if (busy) {
        <div
          class="spinner-border spinner-border-sm m-0"
          aria-label="Loading"></div>
      } @else {
        {{ label || 'Save' }}
      }
      @if (icon) {
        <i
          class="ms-2"
          [ngClass]="iconClass"></i>
      }
    </button>
  `,
})
export class SubmitComponent {
  @Input() busy: boolean = true;
  @Input({ transform: booleanAttribute }) disabled: boolean = false;
  @Input() label?: string;
  @Input() btnClass?: string;
  @Input({ required: true }) btnID!: string;
  @Input() iconClass: string = 'iconoir-arrow-right';
  @Input() icon: boolean = true;
}
